/**
 * @file index.tsx
 *
 * @fileoverview Renders blog text image row.
 * Displays text and image aligned left or right.
 */

import { Image } from '~/jobiqo/types/types';
import { WYSIWYGText } from '~/vcl/atoms/13-text/02-WYSIWYG';
import { SideText } from '~/vcl/organisms/04-landingpage/04-sidetext';

interface BlogTextImageRowProps {
  /**
   * The text to display.
   */
  text: string;
  /**
   * The image alignment
   */
  align: 'left' | 'right';
  /**
   * The image.
   */
  image: Image;
}
export default function BlogTextImageRow({
  text,
  image: { alt, width, height, url, title, caption },
  align,
}: BlogTextImageRowProps) {
  return (
    <SideText
      imageOrientation={align}
      image={{
        url,
        alt: alt ?? '',
        title: title ?? alt ?? '',
        width: width?.toString(),
        height: height?.toString(),
      }}
      caption={caption as string}
    >
      <WYSIWYGText format="full_html" content={text} />
    </SideText>
  );
}

export { BlogTextImageRow };
